/**
 * Bootstrap.
 *
 * Order matters: connectivity listeners and the outbox replay are installed
 * BEFORE React mounts, so a phone that regains signal on the splash screen
 * starts draining queued attendance events immediately rather than waiting for
 * a component to render.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { registerSW } from 'virtual:pwa-register';
import { App } from './App';
import { queryClient } from './lib/queries';
import { installConnectivityListeners } from './lib/sync-status';
import { installOutboxReplay } from './lib/outbox';
import { ToastProvider } from './components/Toast';
import './index.css';

installConnectivityListeners();
installOutboxReplay();

// autoUpdate: a staff phone is never going to tap "reload to update", and a
// stale Staff App is a real operational risk (an old task state machine).
registerSW({ immediate: true });

const container = document.getElementById('root');
if (container === null) throw new Error('Không tìm thấy #root.');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <App />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
